import T from 'utils/T';
import ex from 'utils/ex';

export default function PatientPhysicalInfo(props) {
  const {
    patient,
  } = props || {};
  const {
    height,
    weight,
    bmi,
  } = patient;
  return (
    <div {...ex('PatientPhysicalInfo', props)}>
      {T('{0}cm, {1}kg (BMI {2})', height, weight, bmi)}
    </div>
  );
}
